import { postReactNativeMessage } from 'Utils/ReactNativeRPC';
import AbstractStorage from './AbstractStorage';
const EVENT_TYPE = 'nativeStorage';
export default class NativeStorage extends AbstractStorage {
    static _instance;
    constructor() {
        super();
    }
    static instance() {
        return this._instance || (this._instance = new NativeStorage());
    }
    async getItem(key) {
        const res = await postReactNativeMessage(EVENT_TYPE, {
            action: 'read',
            key
        });
        if (res.action === 'read' && typeof res.value !== 'undefined') {
            if (res.value === null) {
                return null;
            }
            return JSON.parse(res.value);
        }
        else {
            throw new Error(`Failed to get key '${key}' from nativeStorage`);
        }
    }
    async setItem(key, value) {
        const jsonValue = JSON.stringify(value);
        const res = await postReactNativeMessage(EVENT_TYPE, {
            action: 'write',
            key,
            value: jsonValue
        });
        if (res.action !== 'write') {
            throw new Error(`Failed to set key '${key}' to nativeStorage`);
        }
    }
    async removeItem(key) {
        const res = await postReactNativeMessage(EVENT_TYPE, {
            action: 'remove',
            key
        });
        if (res.action !== 'remove') {
            throw new Error(`Failed to remove key '${key}' from nativeStorage`);
        }
    }
    isAvailable() {
        return new Promise((resolve) => {
            const checkAvailable = () => {
                if (!window.ReactNativeWebView) {
                    resolve(false);
                }
                else if (window.supportedEventTypes) {
                    resolve(window.supportedEventTypes.nativeStorage || false);
                }
                else {
                    // It may cost some time for the `window.supportedEventTypes`
                    // to be ready. Wait for some time to check it again.
                    setTimeout(checkAvailable, 100);
                }
            };
            checkAvailable();
        });
    }
}
